export default __webpack_public_path__ + "static/media/blue-loader.ca1aedeb.svg";